import React, { useState, useContext, useRef } from "react";
const moreIcon = require("../../styles/images/more-options.svg");
import { PhotoManagerContext } from "..";
import {
  FolderActionsType,
  SourceEntityToMoveType,
  ParentFolderId
} from "../types";
import { usePopupClickOutside } from "../../../../hooks/usePopupClickOutside";

const FolderActions: React.FC<FolderActionsType> = ({ folder }) => {
  const popupRef = useRef<HTMLDivElement>(null);
  const [showFolderActions, setShowFolderActions] = useState<boolean>(false);
  const context = useContext(PhotoManagerContext);
  usePopupClickOutside(popupRef as React.RefObject<HTMLElement>, () =>
    setShowFolderActions(false)
  );

  // Check if user has any actions available for non-reference folders
  const hasAnyAction =
    folder.isReference ||
    folder.canRename ||
    folder.canMove ||
    folder.canAddShortcut ||
    folder.canManageAccess ||
    folder.canDelete;

  if (!hasAnyAction) return null;

  // Check if middle section has any visible actions (for hr separator logic)
  const hasMiddleActions =
    folder.canMove || folder.canAddShortcut || folder.canManageAccess;

  return (
    <div ref={popupRef} className="geo-flex">
      <div
        onClick={e => {
          e.stopPropagation();
          setShowFolderActions(!showFolderActions);
          context?.setSelectedFolderActions(folder);
        }}
        className="folder-actions"
      >
        <img src={moreIcon} alt="folder-icon" />
      </div>
      {showFolderActions && (
        <div className="folder-actions-div">
          {folder.isReference ? (
            <div
              className="folder-action"
              onClick={e => {
                e.stopPropagation();
                context?.toggleDeleteShortcutModal(true, folder);
                setShowFolderActions(false);
              }}
            >
              Delete shortcut
            </div>
          ) : (
            <>
              {folder.canRename && (
                <div
                  className="folder-action div-border-bottom"
                  onClick={e => {
                    e.stopPropagation();
                    context?.setShowRenameModal();
                    setShowFolderActions(false);
                  }}
                >
                  Rename
                </div>
              )}
              {folder.canRename && (hasMiddleActions || folder.canDelete) && (
                <hr />
              )}
              {folder.canMove && (
                <div
                  className="folder-action div-border-bottom"
                  onClick={e => {
                    const srcEntity: SourceEntityToMoveType & ParentFolderId = {
                      id: folder.id,
                      name: folder.name,
                      type: folder.type,
                      parentFolderId: folder.parentFolderId
                    };
                    e.stopPropagation();
                    context?.setShowMovePopup();
                    setShowFolderActions(false);
                    context?.setSourceEntityTypeToMove(srcEntity);
                  }}
                >
                  Move this folder
                </div>
              )}
              {folder.canAddShortcut && (
                <div
                  className="folder-action div-border-bottom"
                  onClick={e => {
                    e.stopPropagation();
                    context?.toggleFolderFeatureModal(
                      true,
                      folder.id,
                      folder.name,
                      "LibraryFolder",
                      folder.parentFolderId
                    );
                    setShowFolderActions(false);
                  }}
                >
                  Add shortcut
                  <p className="ws-small-grey">
                    Create a shortcut of this folder
                  </p>
                </div>
              )}
              {folder.canManageAccess && (
                <div
                  className="folder-action div-border-bottom"
                  onClick={e => {
                    e.stopPropagation();
                    context?.toggleManagePermissionsModal(
                      true,
                      "LibraryFolder",
                      folder.id,
                      folder.name
                    );
                    setShowFolderActions(false);
                  }}
                >
                  Manage access
                  <p className="ws-small-grey">
                    Control who can view and edit
                  </p>
                </div>
              )}
              {folder.canDelete && (hasMiddleActions || folder.canRename) && (
                <hr />
              )}
              {folder.canDelete && (
                <div
                  className="folder-action"
                  onClick={e => {
                    e.stopPropagation();
                    context?.setShowDeleteModal();
                    setShowFolderActions(false);
                  }}
                >
                  Delete
                </div>
              )}
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default FolderActions;
